import { useLocation } from '@reach/router'
import React, { useState, useContext, useEffect } from 'react'
import { withPrefix } from 'gatsby'
import LanguageContext from '../../contexts/languageContext'
import styles from './styles.module.css'
import UseCasesItem from './UseCasesItem'
import useUseCasesEN from './useUseCases.en'
import useUseCasesES from './useUseCases.es'
import useUseCasesPtBR from './useUseCases.pt-BR'

const UseCaseListWrapper = ({ children, filterBy }) => {
  const [data, setData] = useState([])
  const { lang } = useContext(LanguageContext)
  const location = useLocation()
  const dataBuilded = {
    'pt-BR': useUseCasesPtBR(),
    en: useUseCasesEN(),
    es: useUseCasesES(),
  }[lang]

  useEffect(() => {
    const dataFilteredBy = filterBy
      ? dataBuilded.filter(({ node: useCase }) => {
          const { slug } = useCase.fields
          const isFilteredByCategory = useCase.frontmatter.api === filterBy
          const isSameUseCase = location.pathname === withPrefix(slug)

          return isFilteredByCategory && !isSameUseCase
        })
      : dataBuilded
    setData(dataFilteredBy)
  }, [dataBuilded, filterBy])

  return data.length ? (
    <section className={`${styles.useCases} ${styles.bgGray}`}>
      {children}

      <div className={styles.useCasesGrid}>
        {data.map(({ node: useCase }, index) => (
          <UseCasesItem
            slug={useCase.fields.slug}
            title={useCase.frontmatter.title}
            description={useCase.frontmatter.description}
            key={index}
          />
        ))}
      </div>
    </section>
  ) : (
    <></>
  )
}

export default UseCaseListWrapper
